export default __webpack_public_path__ + "static/media/image.geoedge-pvt-ltd.5d82602d.png";